import { ComponentProps } from 'react';
import Alert from 'antd/es/alert';
import clsx from 'clsx';

import './OpBanner.scss';

interface OpBannerProps
  extends Omit<ComponentProps<typeof Alert>, 'data-testid'> {
  testId?: string;
}

/**
 * OpBanner is a wrapper around Ant Design's Alert component with banner styling.
 * It displays important messages at the top of a page or section with consistent banner appearance.
 * 
 * Use this component for system-wide notifications, warnings, or informational messages that need prominent display.
 * 
 * @example
 * <OpBanner message="System maintenance scheduled" type="warning" closable />
 * 
 */
export const OpBanner = ({
  testId = 'op-banner',
  className,
  ...alertProps
}: OpBannerProps) => {
  return (
    <Alert
      {...alertProps}
      banner
      className={clsx('op-banner', className)}
      data-testid={testId}
    />
  );
};
